/* eslint-disable */
export default {
  all: 'Tudo',
  company: 'Empresa',
  personal: 'Pessoal',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
